import { render, staticRenderFns } from "./LimitTypeFileUploadButton.vue?vue&type=template&id=b7232a94&scoped=true&"
import script from "./LimitTypeFileUploadButton.vue?vue&type=script&lang=js&"
export * from "./LimitTypeFileUploadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7232a94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
